import CallToAction from "../CallToAction/CallToAction.jsx";
import cx from "classnames";
import { shape, string, bool } from "prop-types";

const propTypes = {
  className: string,
  eyebrow: string,
  image: shape({
    imageXSmall: string.isRequired,
    imageSmall: string.isRequired,
    imageMedium: string.isRequired,
    imageLarge: string.isRequired,
  }).isRequired,
  title: string.isRequired,
  subtitle: string,
  readTime: string,
  description: string,
  link: string,
  fromNewsStories: bool,
};

const Promo = (props) => {
  const {
    className,
    eyebrow,
    title,
    image,
    subtitle,
    description,
    link,
    readTime,
    fromNewsStories,
  } = props;

  return (
    <section className={cx("promo", "component", className)}>
      {className === "promo--dark" ? (
        <div className="vertical-line"></div>
      ) : null}
      <div className="promo__content">
        {eyebrow && <div className="promo__eyebrow">{eyebrow}</div>}
        {!fromNewsStories && (
          <h2 className="promo__title">
            <a href="#1">{title}</a>
          </h2>
        )}
        {fromNewsStories && title && (
          <div className="promo__subtitle">
            <a href="#1">{title}</a>
          </div>
        )}
        {subtitle && <div className="promo__subtitle">{subtitle}</div>}
        {description && <div className="promo__desc">{description}</div>}
        {readTime && <div className="promo__read-time">{readTime}</div>}
        {link && (
          <div className="promo__cta">
            <CallToAction children={link} />
          </div>
        )}
      </div>
      {image && (
        <div className="promo__image-wrapper">
          <a href="#1">
            <img
              srcSet={`
              ${image.imageXSmall} 250w,
              ${image.imageSmall} 500w,
              ${image.imageMedium} 620w,
              ${image.imageLarge} 930w
              `}
              sizes="
                (min-width: 1115px) 620px, 
                (min-width: 1060px) calc(57vw - 30px), 
                (min-width: 690px) 620px, 
                calc(100vw - 70px)
              "
              alt=""
              loading="lazy"
            />
          </a>
        </div>
      )}
    </section>
  );
};

Promo.propTypes = propTypes;
export default Promo;
